/** @jsxImportSource @emotion/react */
import {
  List,
  ListItem,
  Typography,
  UtilityButton,
} from '@quickbit/qb-design-system';
import { TransactionRequest, useBatchRestart } from 'api/useDirectOnrampApi';

interface Props {
  transactionRequests: TransactionRequest[];
}
export const BatchActions = ({ transactionRequests }: Props) => {
  const { mutate, data, isPending } = useBatchRestart(
    transactionRequests.map((tr) => tr.referenceId)
  );

  const displayResult = (result: Record<string, boolean> | undefined) => {
    if (!result) return '';
    if (Object.keys(result).length === 1) {
      return Object.values(result)[0] ? 'Success' : 'Failed';
    }
    return (
      <>
        {Object.entries(result).map(([orderId, success]) => (
          <div key={orderId}>
            <Typography variant="bodySmallest">
              {orderId}: {success ? 'Success' : 'Failed'}
            </Typography>
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      <Typography variant="bodyBold">Retry actions</Typography>
      <List>
        <ListItem
          icon={
            !data ? (
              <UtilityButton
                text={'Restart'}
                loading={isPending}
                disabled={isPending}
                onClick={() => mutate()}
              />
            ) : undefined
          }
          title={displayResult(data)}
        />
      </List>
    </>
  );
};
